import { useEffect, useState, useRef, useCallback } from 'react';
export var useAutoPlayInactivity = function (props) {
    var delayBeforeDisplayMs = props.delayBeforeDisplayMs, delayBeforeKickoutMs = props.delayBeforeKickoutMs, onExit = props.onExit;
    var _a = useState(false), isModalOpened = _a[0], setIsModalOpened = _a[1];
    var _b = useState(0), countdown = _b[0], setCountdown = _b[1];
    var timeoutRef = useRef(null);
    var redirectAfterDelay = useCallback(function () {
        var timeoutForExit = setTimeout(function () {
            onExit();
        }, delayBeforeKickoutMs);
        return function () { return clearTimeout(timeoutForExit); };
    }, [onExit, delayBeforeKickoutMs]);
    var resetTimer = useCallback(function () {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(function () {
            setIsModalOpened(true);
        }, delayBeforeDisplayMs);
    }, [delayBeforeDisplayMs]);
    var handleResetModal = function () {
        setIsModalOpened(false);
    };
    useEffect(function () {
        if (isModalOpened) {
            return redirectAfterDelay();
        }
        resetTimer();
        window.addEventListener('mousemove', resetTimer);
        window.addEventListener('keydown', resetTimer);
        window.addEventListener('click', resetTimer);
        window.addEventListener('scroll', resetTimer);
        return function () {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            window.removeEventListener('mousemove', resetTimer);
            window.removeEventListener('keydown', resetTimer);
            window.removeEventListener('click', resetTimer);
            window.removeEventListener('scroll', resetTimer);
        };
    }, [isModalOpened, redirectAfterDelay, resetTimer]);
    useEffect(function () {
        if (!isModalOpened) {
            return;
        }
        setCountdown(Math.ceil(delayBeforeKickoutMs / 1000));
        var interval = setInterval(function () {
            setCountdown(function (prev) {
                if (prev <= 1) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return function () { return clearInterval(interval); };
    }, [isModalOpened, delayBeforeKickoutMs]);
    return {
        isModalOpened: isModalOpened,
        countdown: countdown,
        handleResetModal: handleResetModal,
    };
};
